{
  "name": "genesis-kit",
  "version": "2.0.0",
  "description": "AI-first deterministic dataset generator for algorithm competitions.",
  "keywords": [
    "oi",
    "acm",
    "icpc",
    "algorithm",
    "contest",
    "test-data",
    "generator",
    "dataset",
    "deterministic",
    "ai-first",
    "genesis-kit"
  ],
  "author": "YV",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/yviscool/Genesis/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/yviscool/Genesis.git"
  },
  "bin": {
    "genesis": "dist/cli.js"
  },
  "files": [
    "dist",
    "manifest.schema.json",
    "CHANGELOG.md",
    "MIGRATION.md",
    "README.md",
    "README.en.md",
    "LICENSE"
  ],
  "module": "./dist/index.mjs",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    "./package.json": "./package.json",
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.js",
      "bun": "./dist/bun/index.js",
      "types": "./dist/index.d.ts"
    },
    "./manifest.schema.json": "./manifest.schema.json"
  },
  "scripts": {
    "test": "bun test",
    "dev": "bun --watch run examples/make.ts",
    "build": "bun run build.ts",
    "prepare": "bun run build",
    "build:ai-contract": "bun run scripts/build-ai-contract.ts",
    "release:check": "node scripts/release-check.mjs",
    "release": "bun run release:check && bun publish"
  },
  "devDependencies": {
    "@types/bun": "latest",
    "esbuild-fix-imports-plugin": "latest",
    "tsdown": "^0.16.2"
  },
  "peerDependencies": {
    "@typescript/native-preview": "^7.0.0-dev.20251228.1"
  },
  "dependencies": {
    "cac": "^6.7.14",
    "consola": "^3.4.2",
    "es-toolkit": "^1.43.0",
    "execa": "^9.6.1",
    "ora": "^9.0.0",
    "picocolors": "^1.1.1",
    "tsx": "^4.20.6"
  }
}
